var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comingsoon"},[_c('div',{staticClass:"centered"},[_vm._v("敬请期待")])])
}]

export { render, staticRenderFns }